import employeeMission from '@/api/mission/employee-mission'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  missionTypes: [],
  approvedByEmployees: [],
  assignedByEmployees: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEE(state, data) {
    state.employees = data
  },
  SET_MISSION_TYPES(state, data) {
    state.missionTypes = data
  },
  SET_APPROVED_BY_EMPLOYEES(state, data) {
    state.approvedByEmployees = data
  },
  SET_ASSIGNED_BY_EMPLOYEES(state, data) {
    state.assignedByEmployees = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return employeeMission.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return employeeMission.store(data)
  },
  update(context, { id, data }) {
    return employeeMission.update(id, data)
  },

   destroy(context, id) {
    return employeeMission.destroy(id)
  },


  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await employeeMission.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getEmployee(context, search) {
    let response = await employeeMission.getEmployee(search)
    context.commit('SET_EMPLOYEE', response)
  },

  async getMissionTypes({ commit }) {
    const response = await employeeMission.getMissionTypes()
    commit('SET_MISSION_TYPES', response)
  },

  async getEmployeeCondition({ commit }, employeeId) {
    return await employeeMission.getEmployeeCondition(employeeId)
  },

  async getApprovedByEmployees({ commit }, search) {
    const response = await employeeMission.getEmployee(search)
    commit('SET_APPROVED_BY_EMPLOYEES', response)
  },
  async getAssignedByEmployees({ commit }, search) {
    const response = await employeeMission.getEmployee(search)
    commit('SET_ASSIGNED_BY_EMPLOYEES', response)
  }
}
